import { render, staticRenderFns } from "./work-item-modal-export.component.vue?vue&type=template&id=05b79230&scoped=true&"
import script from "./work-item-modal-export.component.vue?vue&type=script&lang=ts&"
export * from "./work-item-modal-export.component.vue?vue&type=script&lang=ts&"
import style0 from "./work-item-modal-export.component.vue?vue&type=style&index=0&id=05b79230&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b79230",
  null
  
)

export default component.exports